import React from 'react';
import InlineOpenGraph from '../InlineOpenGraph';
import { useOpenGraph } from '../../hooks/useOpenGraph';

const CommentLinkPreviews = ({ text, className = '' }) => {
  const { openGraphData, isLoading, error, urls } = useOpenGraph(text || '');

  // Avoid rendering anything if no URLs detected
  if (!urls || urls.length === 0) return null;

  return (
    <InlineOpenGraph
      openGraphData={openGraphData}
      isLoading={isLoading}
      error={error}
      // No remove in read-only display
      onRemoveCard={null}
      className={className}
    />
  );
};

export default CommentLinkPreviews;
